// extracted by mini-css-extract-plugin
module.exports = {"content":"_3RV-1z3mnM1VkDm1syPtBe","title":"_30-poIg3_KN66hEEZt0M4m","icons":"_2D9owb4GGeZUECeGwS4Ix4"};